<template>
  <v-container>
    <h1 class="text-center delA">NEW BILLING</h1>
    <v-container>
      <div id="printArea">
        <div class="flexBox">
          <div class="flexCont1">
            <p class="caption text-uppercase">
              {{ new Date() | DateAndTime }}
            </p>
          </div>
          <div class="flexCont2">
            <v-img aspect-ratio="2.5" contain src="../assets/printing.svg" />
            <span>{{ company.comapy }}</span>
          </div>
          <div class="flexCont3">
            <p class="caption text-uppercase">
              Ph: {{ company.phone1 }}
              {{ company.phone2 == null ? "" : "/" + company.phone2 }}
            </p>
            <p class="caption">{{ company.webpage }}</p>
          </div>
        </div>
        <v-form ref="customer">
          <v-row class="d-print-none">
            <v-col>
              <v-autocomplete
                v-model="InType"
                :rules="[RULES.required]"
                :items="['CUSTOMER', 'SWIGGY']"
                label="TO "
              ></v-autocomplete>
            </v-col>
            <v-col>
              <v-text-field
                label="Customer Name"
                required
                v-model="customerName"
                :rules="[RULES.required]"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="Customer Contact No /Order No"
                required
                v-model="customerPhone"
                :rules="[RULES.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn dark block color="primary1" @click="saveBill"
                >SAVE BILL</v-btn
              >
            </v-col>
          </v-row>
          <div class="flexBox d-none d-print-flex">
            <div class="flexCont1">
              <span class="caption">{{
                InType == "SWIGGY" ? "ONLINE" : "Name"
              }}</span>
              <span class="caption text-left">{{ customerName }}</span>
            </div>
            <div class="flexCont1">
              <span class="caption"
                >{{ InType == "SWIGGY" ? "ORDER ID" : "Ph" }}:</span
              >
              <span class="caption text-left">{{ customerPhone }}</span>
            </div>
          </div>
          <br />
        </v-form>
        <v-form ref="form" class="delA">
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="new_p_id"
                :rules="[RULES.required, localRule.product, localRule.stock]"
                :items="PRODUCTS"
                item-text="name"
                item-value="pid"
                label="ITEM"
              ></v-autocomplete>
            </v-col>
            <v-col>
              <template v-if="new_price.length > 1">
                <v-select
                  v-model="mrp_rate"
                  :items="new_price"
                  item-text="rate"
                  item-value="rate"
                  label="MRP"
                  persistent-hint
                  return-object
                  :rules="[RULES.required]"
                  single-line
                ></v-select>
              </template>
              <template v-else>
                <v-text-field
                  label="MRP"
                  required
                  v-model="mrp_rate"
                  :rules="[RULES.required, RULES.mrp]"
                ></v-text-field>
              </template>
            </v-col>
            <v-col>
              <v-text-field
                label="Qty"
                required
                v-model="new_qty"
                :rules="[RULES.required, RULES.mrp, localRule.Qty]"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="₹/Per"
                required
                v-model="org_price"
                :rules="[RULES.required, RULES.mrp]"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="GST"
                required
                v-model="prod_gst"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="₹ TOTAL"
                required
                readonly
                v-model="new_total"
                :rules="[RULES.required, RULES.mrp]"
              ></v-text-field>
            </v-col>
            <v-col cols="1">
              <v-btn fab small @click="addItem" color="green">
                <v-icon color="#fff">mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
        <template v-if="items.length >= 1">
          <div>
            <table
              style="
                width: 100%;
                height: 100%;
                border-bottom: 1px solid black;
                border-top: 1px solid black;
              "
            >
              <tr>
                <td class="text-center" style="border-right: 1px solid black">
                  ITEM NAME
                </td>
                <td class="text-center" style="border-right: 1px solid black">
                  MRP ₹
                </td>
                <td class="text-center" style="border-right: 1px solid black">
                  Rate ₹
                </td>
                <td class="text-center" style="border-right: 1px solid black">
                  Qty
                </td>
                <td class="text-center" style="border-right: 1px solid black">
                  Amount
                </td>
                <td class="text-center" style="border-right: 1px solid black">
                  GST
                </td>
                <td class="text-center">Total</td>
                <td class="delA" style="border-left: 1px solid black"></td>
              </tr>
              <tr v-for="(i, index) in items" :key="index">
                <td
                  style="
                    border-right: 1px solid black;
                    border-top: 1px solid black;
                  "
                >
                  {{ i.name }}
                </td>
                <td
                  style="
                    border-right: 1px solid black;
                    border-top: 1px solid black;
                  "
                >
                  {{ i.mrp }}
                </td>
                <td
                  style="
                    border-right: 1px solid black;
                    border-top: 1px solid black;
                  "
                >
                  {{ i.rate }}
                </td>
                <td
                  style="
                    border-right: 1px solid black;
                    border-top: 1px solid black;
                  "
                >
                  {{ i.qty }}
                </td>
                <td
                  style="
                    border-right: 1px solid black;
                    border-top: 1px solid black;
                  "
                >
                  {{ i.amount }}
                </td>
                <td
                  style="
                    border-right: 1px solid black;
                    border-top: 1px solid black;
                  "
                >
                  {{ i.cgst + "(CGST) + " + i.sgst + " (SGST)" }}
                </td>
                <td style="border-top: 1px solid black">
                  {{ i.total | rupee }}
                </td>
                <td
                  width="5%"
                  style="
                    border-top: 1px solid black;
                    border-left: 1px solid black;
                  "
                  class="delA"
                >
                  <v-btn fab small color="red" @click="del(index)">
                    <v-icon color="#fff">mdi-minus</v-icon>
                  </v-btn>
                </td>
              </tr>
            </table>
            <br />
            <v-row>
              <v-col>
                <p>SUB TOTAL</p>
                <p>{{ subtotal }}</p>
              </v-col>
              <v-col>
                <v-text-field
                  label="Discount %"
                  required
                  v-model="discount"
                  :rules="[RULES.required]"
                ></v-text-field>
              </v-col>
              <v-col class="text-right">
                <p>TOTAL</p>
                <p>
                  <b>{{ grandTotal }}</b>
                </p>
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-else>
          <v-alert type="info" class="text-center">NO ITEMS SELECTED.</v-alert>
        </template>
      </div>
    </v-container>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      customerName: "",
      customerPhone: "",
      InType: "CUSTOMER",
      availStock: 0,
      company: {},
      items: [],
      grandTotal: 0,
      subtotal: 0,
      new_p_id: "",
      new_name: "",
      new_qty: 1,
      new_price: 1,
      new_total: 1,
      productStore: {},
      org_price: 1,
      amount: 0,
      prod_gst: 0,
      cgst: 0,
      sgst: 0,
      p_cgst: 0,
      p_sgst: 0,
      discount: 0,
      dicoundAdder: 0,
      mrp_rate: 1,
      localRule: {
        product: (val) => {
          return (
            !this.items.some((el) => el.p_id === val) || "Item already exists"
          );
        },
        stock: (val) => {
          return (
            this.SHOPDATA.some((el) => el.p_id === val && el.stock >= 1) ||
            "OUT OF STOCK"
          );
        },
        Qty: (val) => {
          return (
            this.productStore.stock >= val ||
            "We Have Only " +
              (this.productStore.stock == undefined
                ? 0
                : this.productStore.stock)
          );
        },
        rupCheck: (val) => {
          if (typeof val == "object") {
            return val.rate >= 1 || "Should be grater than 1";
          } else {
            return Number(val) >= 1 || "Should be grater than 1";
          }
        },
      },
    };
  },
  created() {
    this.company = this.$session.get("company");
  },
  activated() {
    this.getBillData();
    this.saved = false;
    this.company = this.$session.get("company");
  },
  computed: {
    ...mapGetters(["RULES", "PRODUCTS", "SHOPDATA"]),
  },
  methods: {
    ...mapActions(["GET_BILLING", "GET_BILLING_NEW"]),
    getBillData() {
      this.$store.commit("SET_LOADING", true);
      this.GET_BILLING().then(() => {
        this.$store.commit("SET_LOADING", false);
      });
    },
    addItem() {
      if (this.$refs.form.validate()) {
        this.items.push({
          name: this.new_name,
          rate: this.org_price,
          qty: this.new_qty,
          total: this.new_total,
          p_id: this.new_p_id,
          p_cgst: this.p_cgst,
          p_sgst: this.p_sgst,
          sgst: this.sgst,
          cgst: this.cgst,
          amount: this.amount,
          mrp: this.mrp_rate,
        });
        this.subtotal = Number(this.subtotal) + Number(this.amount);
        this.grandTotal = Number(this.grandTotal) + Number(this.new_total);
        this.dicoundAdder = Number(this.dicoundAdder) + Number(this.new_total);
        this.new_name = "";
        this.org_price = 1;
        this.new_qty = 1;
        this.new_total = 1;
        this.new_p_id = "";
        this.p_cgst = 0;
        this.p_sgst = 0;
        this.sgst = 0;
        this.cgst = 0;
        this.amount = 0;
        this.prod_gst = 0;
      }
    },
    del(index) {
      this.subtotal -= this.items[index].amount;
      this.grandTotal -= this.items[index].total;
      this.dicoundAdder -= this.items[index].total;
      this.items.splice(index, 1);
    },
    saveBill() {
      if (this.$refs.customer.validate() && this.items.length >= 1) {
        this.$store.commit("SET_LOADING", true);
        this.GET_BILLING_NEW({
          type: this.InType,
          name: this.customerName,
          phone: this.customerPhone,
          items: this.items,
          total: this.grandTotal,
          subtotal: this.subtotal,
          discount: this.discount,
          grandtotal: this.grandTotal,
        }).then(() => {
          this.customerPhone = "";
          this.customerName = "";
          this.items = [];
          this.grandTotal = 0;
          this.new_p_id = "";
          this.new_name = "";
          this.new_qty = 1;
          this.new_price = 1;
          this.new_total = 1;
          this.productStore = {};
          this.$store.commit("SET_LOADING", false);
        });
      }
    },
    totalCalc() {
      if (
        this.prod_gst >= 1 &&
        this.prod_gst != "" &&
        this.org_price >= 1 &&
        this.new_qty >= 1
      ) {
        this.amount = this.new_qty * this.org_price;
        this.p_cgst = this.prod_gst / 2;
        this.p_sgst = this.prod_gst / 2;
        this.cgst = (
          ((this.new_qty * this.org_price) / 100) *
          this.p_cgst
        ).toFixed(2);
        this.sgst = (
          ((this.new_qty * this.org_price) / 100) *
          this.p_sgst
        ).toFixed(2);
        this.new_total = (
          this.new_qty * this.org_price +
          Number(this.cgst) +
          Number(this.sgst)
        ).toFixed(2);
      } else if (this.prod_gst == 0) {
        this.amount = this.new_qty * this.org_price;
        this.new_total = (
          Number(this.new_qty) * Number(this.org_price)
        ).toFixed(2);
      }
    },
  },
  watch: {
    new_p_id(val) {
      if (val != "") {
        let selProd = this.PRODUCTS.filter((i) => {
          return i.pid == val;
        })[0];
        this.productStore = this.SHOPDATA.filter((i) => {
          return i.p_id == selProd.pid;
        })[0];
        if (this.productStore != undefined) {
          this.new_name = selProd.name;
          console.log(this.productStore);
          this.new_price = this.productStore.rates.split(",");
          let newMrps = this.productStore.mrp.split(",");
          if (this.new_price.length > 1) {
            let objArr = [];
            let stockArr = this.productStore.mrp_stocks.split(",");
            this.new_price.forEach((el, ind) => {
              objArr.push({
                stock: stockArr[ind],
                mrp: el,
                rate: newMrps[ind],
              });
            });
            this.new_price = objArr;
            this.mrp_rate = this.new_price[0];
            this.org_price = this.mrp_rate.mrp;
            this.availStock = this.mrp_rate.stock;
            console.log(this.new_price);
          } else {
            this.org_price = this.new_price[0];
            this.mrp_rate = newMrps[0];
          }
        }
      }
    },
    new_qty(val) {
      this.totalCalc();
    },
    org_price(val) {
      this.totalCalc();
    },
    mrp_rate(val) {
      if (typeof val == "object") {
        this.mrp_rate = val.mrp;
      } else {
        this.totalCalc();
      }
    },
    prod_gst(val) {
      if (val >= 1) {
        this.totalCalc();
      } else {
        this.cgst = 0;
        this.sgst = 0;
        this.p_cgst = 0;
        this.p_sgst = 0;
        this.new_total = (
          Number(this.new_qty) * Number(this.org_price)
        ).toFixed(2);
      }
    },
    discount(val) {
      if (val >= 1) {
        let dicRate = parseInt((this.dicoundAdder / 100) * this.discount);
        this.grandTotal = (Number(this.dicoundAdder) - dicRate).toFixed(2);
      } else {
        this.grandTotal = this.dicoundAdder;
      }
    },
    InType(val) {
      if (val == "SWIGGY") {
        this.customerName = "SWIGGY";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.flexBox {
  display: flex;
  .flexCont1 {
    text-align: left;
    justify-content: start;
    flex: 1;
  }
  .flexCont2 {
    text-align: center;
    flex: 1;
    justify-content: center;
  }
  .flexCont3 {
    flex: 1;
    text-align: right;
    justify-content: end;
  }
}
</style>